module.exports = __webpack_public_path__ + "img/15.71867802.jpg";